// src/pages/IntroPage.jsx - Design D-Light: Premium Split (Light Theme)
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './IntroPage.css';
import logoMapGroup from '../logo-map-group.png';

export default function IntroPage() {
    const navigate = useNavigate();
    const [progress, setProgress] = useState(0);
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        const STEP_MS = 40;
        const STEP_VAL = 2;
        const t = setInterval(() => {
            setProgress((p) => Math.min(100, p + STEP_VAL));
        }, STEP_MS);
        return () => clearInterval(t);
    }, []);

    useEffect(() => {
        if (progress >= 100) {
            setIsComplete(true);
            const done = setTimeout(() => navigate('/main', { replace: true }), 600);
            return () => clearTimeout(done);
        }
    }, [progress, navigate]);

    return (
        <div className={`intro-split ${isComplete ? 'exit' : ''}`}>
            {/* 배경 */}
            <div className="split-bg">
                <div className="bg-gradient"></div>
                <div className="bg-pattern"></div>
                <div className="bg-blur bg-blur-1"></div>
                <div className="bg-blur bg-blur-2"></div>
            </div>

            {/* 컨텐츠 래퍼 */}
            <div className="split-content">
                {/* 왼쪽: 브랜드 섹션 */}
                <div className="split-left">
                    <div className="brand-section">
                        <img src={logoMapGroup} alt="MAP GROUP" className="split-logo" />
                        <div className="brand-text">
                            <h1 className="brand-title">
                                <span className="title-line">Corporate</span>
                                <span className="title-line accent">Information</span>
                                <span className="title-line">System</span>
                            </h1>
                            <p className="brand-desc">
                                MAP Group의 영업 관리 시스템에<br />
                                접속하고 있습니다
                            </p>
                        </div>
                    </div>
                </div>

                {/* 오른쪽: 프로그레스 섹션 */}
                <div className="split-right">
                    <div className="progress-card">
                        {/* 상태 인디케이터 */}
                        <div className="status-indicator">
                            <div className="status-dot"></div>
                            <span className="status-text">Connecting</span>
                        </div>

                        {/* 프로그레스 숫자 */}
                        <div className="progress-display">
                            <span className="progress-num">{progress}</span>
                            <span className="progress-unit">%</span>
                        </div>

                        {/* 프로그레스 바 */}
                        <div className="progress-bar-container">
                            <div className="progress-bar-track">
                                <div
                                    className="progress-bar-fill"
                                    style={{ width: `${progress}%` }}
                                >
                                    <div className="progress-bar-shine"></div>
                                </div>
                            </div>
                        </div>

                        {/* 단계 표시 */}
                        <div className="progress-steps">
                            <div className={`step ${progress >= 0 ? 'active' : ''}`}>
                                <div className="step-dot"></div>
                                <span>Initialize</span>
                            </div>
                            <div className={`step ${progress >= 33 ? 'active' : ''}`}>
                                <div className="step-dot"></div>
                                <span>Authenticate</span>
                            </div>
                            <div className={`step ${progress >= 66 ? 'active' : ''}`}>
                                <div className="step-dot"></div>
                                <span>Load Data</span>
                            </div>
                            <div className={`step ${progress >= 100 ? 'active' : ''}`}>
                                <div className="step-dot"></div>
                                <span>Complete</span>
                            </div>
                        </div>

                        {/* 면책 */}
                        <div className="split-notice">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                            </svg>
                            <span>본 자료는 MAP Group의 지식재산입니다</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
